import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

function Success() {
  const [sessionId, setSessionId] = useState('')

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const id = urlParams.get('session_id')
    if (id) {
      setSessionId(id)
    }
  }, [])

  return (
    <div className="bg-gradient-to-br from-indigo-50 via-white to-cyan-50 min-h-screen flex items-center justify-center p-2">
      <div className="max-w-2xl w-full">
        <div className="bg-white rounded-3xl shadow-2xl p-4 sm:p-12 text-center">
          {/* Success Icon */}
          <div className="w-20 h-20 bg-gradient-to-br from-green-400 to-emerald-500 rounded-full flex items-center justify-center mx-auto mb-6">
            <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>

          {/* Success Message */}
          <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4">
            Welcome to Wurlo! 🎉
          </h1>
          <p className="text-lg text-slate-600 mb-8">
            Your payment was successful! You now have <strong>lifetime access</strong> to Wurlo.
          </p>

          {/* What's Next */}
          <div className="bg-gradient-to-br from-indigo-50 to-cyan-50 rounded-2xl p-6 mb-8 text-left">
            <h2 className="text-xl font-bold text-slate-900 mb-4">What happens next?</h2>
            <ul className="space-y-3 text-slate-700">
              <li className="flex items-start gap-3">
                <svg className="w-6 h-6 text-indigo-600 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                </svg>
                <span>Check your email for your receipt and account details</span>
              </li>
              <li className="flex items-start gap-3">
                <svg className="w-6 h-6 text-indigo-600 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
                <span>We'll send you early access before the December 2025 launch</span>
              </li>
              <li className="flex items-start gap-3">
                <svg className="w-6 h-6 text-indigo-600 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
                </svg>
                <span>Get ready to experience adaptive learning like never before</span>
              </li>
            </ul>
          </div>

          {/* CTA Button */}
          <Link to="/" className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-indigo-600 to-cyan-600 text-white px-8 py-4 rounded-xl font-bold text-lg hover:from-indigo-700 hover:to-cyan-700 transition-all shadow-lg hover:shadow-xl">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
            </svg>
            Back to Home
          </Link>
        </div>

        {/* Session ID (hidden, for debugging) */}
        {sessionId && (
          <p className="text-center text-sm text-slate-500 mt-4">Session: {sessionId}</p>
        )}
        
        {/* Footer Links */}
        <div className="text-center text-sm text-slate-500 mt-6">
          <Link to="/terms" className="text-indigo-600 hover:text-indigo-700 underline">Terms & Conditions</Link>
          <span className="mx-2">•</span>
          <Link to="/privacy" className="text-indigo-600 hover:text-indigo-700 underline">Privacy Policy</Link>
          <span className="mx-2">•</span>
          <a href="mailto:contact@wurlo.org" className="text-indigo-600 hover:text-indigo-700 underline">Contact</a>
        </div>
      </div>
    </div>
  )
}

export default Success
